import React from 'react';
import about_1 from '../assets/images/charity/a1.jpg';
import about_2 from '../assets/images/charity/a2.jpg';
import about_3 from '../assets/images/charity/a3.jpg';
import about_0 from '../assets/images/charity/a0.jpg';
// import group3 from '../assets/images/group3.png';

const About = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="container mx-auto px-4">
        <section class="max-w-[1200px] w-full flex flex-col lg:flex-row gap-4 md:gap-10 mt-5 md:mt-8 mb-4 md:mb-8 m-auto">
          <div class="lg:w-2/4 flex flex-col gap-1 p-5 border border-[#f9ab6b8a] rounded-xl">
            <h1 class="text-center mb-2 md:mb-4 text-lg lg:text-3xl text-[#fe6601] font-bold">
              GIỚI THIỆU VỀ GK88
            </h1>
            <p class="text-[#242424] font-roboto font-medium text-justify">
              GK88 không chỉ là đơn vị tiên phong trong lĩnh vực giải trí đa dạng và đổi mới không
              ngừng, mà còn là người đồng hành tận tâm cùng cộng đồng. Chúng tôi cam kết mang đến
              những trải nghiệm chất lượng, đồng thời lan tỏa giá trị nhân văn qua các hoạt động xã
              hội, thiện nguyện và truyền thông. Với tâm huyết và trách nhiệm, GK88 kết nối những
              tấm lòng yêu thương, góp phần xây dựng một xã hội bền vững, nơi mỗi cá nhân đều có cơ
              hội phát triển và sẻ chia hạnh phúc.
            </p>
          </div>
          <div class="flex-1">
            <img class="w-full" alt="GK88" src={about_0} loading="eager" decoding="async" />
          </div>
        </section>
        <div className="flex flex-col w-full max-w-screen-xl md:min-w-[512px] mx-auto items-center space-y-8">
          <div className="w-full max-w-[1200px]">
            <div class="font-bold text-lg lg:text-3xl text-[#fe6601] pt-2 mb-4 text-center">
              TẦM NHÌN HƯỚNG TỚI CỘNG ĐỒNG
            </div>
            <div class="rounded-2xl overflow-hidden shadow-lg">
              <img
                class="w-full"
                alt="TẦM NHÌN HƯỚNG TỚI CỘNG ĐỒNG"
                src={about_1}
                loading="lazy"
                decoding="async"
              />
              <div class="px-2 lg:px-6 py-4 bg-[#fff5f0] border border-[#fe6601] border-t rounded-b-2xl">
                <p class="text-gray-700 text-sm font-medium lg:text-base text-justify">
                  Tại GK88, con người luôn là trái tim của mọi hoạt động. Chúng tôi không ngừng tiên
                  phong trong những chương trình thiện nguyện trên khắp mọi miền, từ việc chắp cánh
                  ước mơ cho trẻ em vùng sâu vùng xa, sẻ chia yêu thương với những hoàn cảnh khó
                  khăn, đến việc bảo vệ môi trường và nâng cao sức khỏe cộng đồng. Bởi chúng tôi tin
                  rằng, mỗi hành động dù nhỏ, khi được trao đi bằng tấm lòng chân thành, đều có thể
                  tạo nên những bước chuyển mình mạnh mẽ, góp phần xây dựng một xã hội tràn đầy hy
                  vọng, nhân ái và bền vững.
                </p>
              </div>
            </div>
          </div>
          <div class="w-full max-w-[1200px]">
            <div class="font-bold text-lg lg:text-3xl text-[#fe6601] pt-2 mb-4 text-center">
              TRUYỀN THÔNG &amp; KẾT NỐI
            </div>
            <div class="rounded-2xl overflow-hidden shadow-lg">
              <img
                class="w-full"
                alt="TRUYỀN THÔNG &amp; KẾT NỐI"
                src={about_2}
                loading="lazy"
                decoding="async"
              />
              <div class="px-2 lg:px-6 py-4 bg-[#fff5f0] border border-[#fe6601] border-t rounded-b-2xl">
                <p class="text-gray-700 text-sm font-medium lg:text-base text-justify">
                  Ngoài các hoạt động thiện nguyện, GK88 còn sôi nổi tham gia các chiến dịch truyền
                  thông xã hội nhằm nâng cao nhận thức về những vấn đề quan trọng như giáo dục, sức
                  khỏe, bảo vệ trẻ em và môi trường. Không chỉ là thương hiệu giải trí, GK88 còn là
                  cầu nối lan tỏa những thông điệp tích cực, khuyến khích mọi người cùng chung tay
                  tạo nên thay đổi thực sự cho cộng đồng.
                </p>
              </div>
            </div>
          </div>
          <div class="w-full max-w-[1200px]">
            <div class="font-bold text-lg lg:text-3xl text-[#fe6601] pt-2 mb-4 text-center">
              TẦM NHÌN &amp; CAM KẾT
            </div>
            <div class="rounded-2xl overflow-hidden shadow-lg">
              <img
                class="w-full"
                alt="TẦM NHÌN &amp; CAM KẾT"
                src={about_3}
                loading="lazy"
                decoding="async"
              />
              <div class="px-2 lg:px-6 py-4 bg-[#fff5f0] border border-[#fe6601] border-t rounded-b-2xl">
                <p class="text-gray-700 text-sm font-medium lg:text-base text-justify">
                  GK88 không chỉ tập trung xây dựng vị thế hàng đầu trong lĩnh vực giải trí mà còn
                  hướng đến việc trở thành một lực lượng tích cực, tạo dấu ấn sâu sắc trong cộng
                  đồng. Chúng tôi cam kết mở rộng các chương trình hỗ trợ, phát triển những dự án
                  bền vững và tăng cường kết nối với cộng đồng, cùng nhau kiến tạo một tương lai
                  tươi sáng, giàu giá trị và đầy cảm hứng. GK88 – Kết nối đam mê, kiến tạo tương
                  lai.
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* <div class="w-full lg:w-1/2 max-w-[1000px] mt-10 mx-auto text-justify">
          <h2 class="text-center mb-4 text-lg lg:text-3xl text-[#fe6601] font-bold">
            ĐỊNH HƯỚNG PHÁT TRIỂN NĂM 2025
          </h2>
          <p class="text-sm lg:text-base text-center">
            <span class="text-[#fe6601] font-bold">
              Lan tỏa yêu thương, kết nối hành động – không ai bị bỏ lại phía sau.
            </span>
            <br />
            GK88 mong muốn đồng hành cùng cộng đồng, để mọi người – dù ở thành thị hay nông thôn –
            đều có cơ hội được quan tâm, sẻ chia và phát triển.
          </p>
        </div>
        <div class="w-full max-w-[1200px] mt-7 mx-auto text-justify">
          <img alt="group3" class="w-full" src={group3} />
        </div> */}
      </div>
    </div>
  );
};

export default About;
